"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArchivedBasketsStatus = exports.getTempEditBasketData = exports.getSimplifiedOfferExtra = exports.getSearchBasketFormUi = exports.getRemoveClaimFromBasketUi = exports.getOffersReviewsLinks = exports.getOffersExtra = exports.getOfferPositionInBasket = exports.getOfferExtra = exports.getManagers = exports.getInitialOpenedBasketId = exports.getFirstSimplifiedBasketOffersCount = exports.getBasketsSimplifiedPerPage = exports.getBasketsSimplifiedPagination = exports.getBasketsSimplified = exports.getBasketsPagination = exports.getBasketsByOrder = exports.getBasketTemplates = exports.getBasketSimplifiedByID = exports.getBasketById = void 0;
var _reselect = require("reselect");
var R = _interopRequireWildcard(require("ramda"));
var _connectedReactRouter = require("connected-react-router");
var _selectors = require("../../../bus/ui/selectors");
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var EMPTY_OBJECT = {};
var getBasketID = function getBasketID(_, _ref) {
  var basketID = _ref.basketID;
  return basketID;
};
var getOfferID = function getOfferID(_, _ref2) {
  var offerID = _ref2.offerID;
  return offerID;
};
var domain = function domain(_) {
  return _.rootBaskets;
};
var getBasketsOrderIDs = R.pipe(domain, R.prop('basketsOrderIDs'));
var getBaskets = R.pipe(domain, R.prop('baskets'));
var getBasketsSimplified = exports.getBasketsSimplified = R.pipe(domain, R.prop('basketsSimplified'));
var getBasketsSimplifiedPagination = exports.getBasketsSimplifiedPagination = R.pipe(domain, R.prop('basketsSimplifiedPagination'));
var getOffersReviewsLinks = exports.getOffersReviewsLinks = R.pipe(domain, R.prop('offersReviewsLinks'));
var getBasketTemplates = exports.getBasketTemplates = R.pipe(domain, R.prop('templates'));
var getBasketsSimplifiedPerPage = exports.getBasketsSimplifiedPerPage = R.pipe(getBasketsSimplifiedPagination, R.prop('perPage'));
var getActiveBasketsStatus = R.pipe(domain, R.prop('activeBasketsStatus'));
var isArchivedBasketsStatus = exports.isArchivedBasketsStatus = R.pipe(getActiveBasketsStatus, R.equals(_constants.BASKET_STATUSES_MAP.ARCHIVE));
var getBasketSimplifiedByID = exports.getBasketSimplifiedByID = R.useWith(function (basketsSimplified, basketID) {
  return R.find(R.propEq(basketID, 'id'), basketsSimplified);
}, [getBasketsSimplified, function (_ref3) {
  var basketID = _ref3.basketID;
  return basketID;
}]);
var getFirstSimplifiedBasket = (0, _reselect.createSelector)(getBasketsSimplified, R.head);
var EMPTY_OFFERS_COUNT = 0;
var getFirstSimplifiedBasketOffersCount = exports.getFirstSimplifiedBasketOffersCount = R.pipe(getFirstSimplifiedBasket, R.pipe(R.prop('offers'), function (offers) {
  return R.length(offers) || EMPTY_OFFERS_COUNT;
}));
var getSimplifiedOffers = R.pipe(getBasketSimplifiedByID, R.prop('offers'));
var getSimplifiedOffer = function getSimplifiedOffer(state, _ref4) {
  var offerID = _ref4.offerID,
    basketID = _ref4.basketID;
  return R.call(R.find(R.propEq(offerID, 'id')), getSimplifiedOffers(state, {
    basketID: basketID
  }));
};
var getSimplifiedOfferExtra = exports.getSimplifiedOfferExtra = R.pipe(getSimplifiedOffer, R.prop('extra'));
var getBasketsPagination = exports.getBasketsPagination = R.pipe(domain, R.prop('pagination'));
var getBasketById = exports.getBasketById = R.converge(function (baskets, basketID) {
  return baskets[basketID];
}, [getBaskets, getBasketID]);
var getOffersExtra = exports.getOffersExtra = R.pipe(getBasketById, R.prop('offersExtra'));
var getBasketOffersIDs = R.pipe(getBasketById, R.prop('offersIDs'));
var getOfferPositionInBasket = exports.getOfferPositionInBasket = R.converge(function (offersIDs, offerID) {
  return R.indexOf(offerID, offersIDs);
}, [getBasketOffersIDs, getOfferID]);
var getTempEditBasketsData = R.pipe(domain, R.prop('tempEditBasketsData'));
var getTempEditBasketData = exports.getTempEditBasketData = R.useWith(function (tempEditBasketsData, basketID) {
  return R.propOr(EMPTY_OBJECT, basketID, tempEditBasketsData);
}, [getTempEditBasketsData, function (_ref5) {
  var basketID = _ref5.basketID;
  return basketID;
}]);
var getOfferExtra = exports.getOfferExtra = R.converge(function (offersExtra, offerID) {
  return offersExtra[offerID];
}, [getOffersExtra, getOfferID]);
var getBasketsByOrder = exports.getBasketsByOrder = (0, _reselect.createSelector)(getBasketsOrderIDs, getBaskets, function (ids, baskets) {
  return R.map(function (id) {
    return baskets[id];
  }, ids);
});
var getManagers = exports.getManagers = R.pipe(domain, R.prop('managers'));
var getSearchBasketFormUi = exports.getSearchBasketFormUi = R.partialRight(_selectors.getUI, [{
  key: _constants.SEARCH_BASKET_UI
}]);
var getRemoveClaimFromBasketUi = exports.getRemoveClaimFromBasketUi = R.partialRight(_selectors.getUI, [{
  key: _constants.REMOVE_CLAIM_FROM_BASKET_UI
}]);
var getInitialOpenedBasketId = exports.getInitialOpenedBasketId = (0, _reselect.createSelector)(_connectedReactRouter.getSearch, function (search) {
  return Number(new URLSearchParams(search).get('id'));
});